<script setup lang="ts">
import { onMounted, ref } from 'vue';

import SimpleLoader from '@/components/loaders/SimpleLoader.vue';
import { fetchGetJobsBookedLog } from '@/helpers/fetchers';

export interface Props {
  logId?: number;
}
export type TableFoldProps = Props;
const props = withDefaults(defineProps<Props>(), {
  logId: NaN,
});

const isLoading = ref(false);
const log = ref<unknown>();

onMounted(async function () {
  isLoading.value = true;
  try {
    log.value = await fetchGetJobsBookedLog({ logId: props.logId });
  } catch {
    // Fetch errors are notified inside the fetcher
  } finally {
    isLoading.value = false;
  }
});
</script>

<template>
  <section
    data-testid="bookedJobLogTableFold"
    :class="$style.bookedJobLogTableFold"
  >
    <div v-if="isLoading" :class="$style.loader">
      <SimpleLoader :size="32" :width="3" />
    </div>
    <small v-else
      ><code>
        <pre :class="$style.log">{{ JSON.stringify(log, null, '  ') }}</pre>
      </code></small
    >
  </section>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';

.bookedJobLogTableFold {
}
  .loader {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
  }
  .log {
    margin: 0;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
  }
</style>
